import { defineMessages } from 'react-intl';

export default defineMessages({
  regulationRequestTitle: {
    id: 'legal-proceedings.regulationRequestTitle',
  },
  regulationRecapTitle: {
    id: 'legal-proceedings.regulationRecapTitle',
  },
  riskTitle: {
    id: 'legal-proceedings.riskTitle',
  },
  addRisk: {
    id: 'legal-proceedings.addRisk',
  },
  noDataTitle: {
    id: 'legal-proceedings.noDataTitle',
  },
  noDataSecondaryTitle: {
    id: 'legal-proceedings.noDataTitle',
  },
  cancel: {
    id: 'legal-proceedings.risk.cancel',
  },
  cancelDialog: {
    id: 'legal-proceedings.risk.cancel_dialog',
  },
  next: {
    id: 'legal-proceedings.risk.next',
  },
  selectAll: {
    id: 'legal-proceedings.select.all',
  },
  riskRecapTitle: {
    id: 'legal-proceedings.riskRecapTitle',
  },
  riskVictims: {
    id: 'legal-proceedings.risk.victims',
  },
  riskVehicles: {
    id: 'legal-proceedings.risk.vehicles',
  },
  riskGarenties: {
    id: 'legal-proceedings.risk.garenties',
  },
  riskRecapGarenties: {
    id: 'legal-proceedings.risk.recap_garenties',
  },
  riskRecapVehicles: {
    id: 'legal-proceedings.risk.recap_vehicles',
  },
  riskRecapVictims: {
    id: 'legal-proceedings.risk.recap_victims',
  },
  riskInfo: {
    id: 'legal-proceedings.risk.information',
  },
  provisionVictimDialog: {
    id: 'provision_victim_dialog',
  },
  provisionIntervenantDialog: {
    id: 'provision_intervenant_dialog',
  },
  town: {
    id: 'legal-proceedings.risk.information.town',
  },
  processNature: {
    id: 'legal-proceedings.risk.information.procedure_nature',
  },
  opposingLawyer: {
    id: 'legal-proceedings.risk.information.opposing_lawyer',
  },
  opposingLawyerCity: {
    id: 'legal-proceedings.risk.information.opposing_lawyer_city',
  },
  opposingLawyerAddress: {
    id: 'legal-proceedings.risk.information.opposing_lawyer_address',
  },
  opposingLawyerEmail: {
    id: 'legal-proceedings.risk.information.opposing_lawyer_email',
  },
  opposingLawyerEmailError: {
    id:
      'legal-proceedings.risk.information.opposing_lawyer_email.error_message',
  },
  settlementDateError: {
    id: 'legal-proceedings.risk.information.settlement_date.error_message',
  },
  judgementDate: {
    id: 'legal-proceedings.risk.information.judgement_date',
  },
  appealDate: {
    id: 'legal-proceedings.risk.information.appeal_date',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
  iddField: {
    id: 'legal-proceedings.risk.information.idd',
  },
  iddConfirm: {
    id: 'legal-proceedings.risk.information.idd_confirm',
  },
  iddRefuse: {
    id: 'legal-proceedings.risk.information.idd_refuse',
  },
  iddDate: {
    id: 'legal-proceedings.risk.information.idd_date',
  },
  regulationDate: {
    id: 'legal-proceedings.risk.information.regulation_date',
  },
  regulationNature: {
    id: 'legal-proceedings.risk.information.regulation_nature',
  },
  beneficiaryTitle: {
    id: 'legal-proceedings.risk.beneficiaries',
  },
  taxAmount: {
    id: 'legal-proceedings.risk.information.bnej_tax_amount',
  },
  costs: {
    id: 'legal-proceedings.risk.information.costs',
  },
  courtNumber: {
    id: 'legal-proceedings.risk.information.court_number',
  },
  beneficiariesTitle: {
    id: 'legal-proceedings.risk.recap_beneficiaries',
  },
  judgementOnMeritsVictimsNotFound: {
    id: 'legal-proceedings.risk.judgement_on_merits.victims_not_found',
  },
  judgementOnMeritsVehiclesNotFound: {
    id: 'legal-proceedings.risk.judgement_on_merits.vehicles_not_found',
  },
  recipient: {
    id: 'legal-proceedings.risk.information.recipient',
  },
  regulationPhase: {
    id: 'legal-proceedings.risk.information.regulation_phase',
  },
  iddDeduction: { id: 'legal-proceedings.risk.information.idd_deduction' },
  iddDeductionPercentage: {
    id: 'legal-proceedings.risk.information.idd_deduction_percentage',
  },
  realBeneficiary: { id: 'legal-proceedings.risk.information.realBeneficiary' },
  cdraRealBeneficiary: { id: 'legal-proceedings.risk.information.cdra_bar' },
  beneficiaryReference: {
    id: 'legal-proceedings.risk.information.beneficiaryReference',
  },
  country: {
    id: 'legal-proceedings.risk.information.country',
  },
  additionalAddress: {
    id: 'legal-proceedings.risk.information.additional_address',
  },
  confirmJudgementOnMerits: {
    id: 'legal-proceedings.risk.confirm_jom',
  },
  confirm: {
    id: 'legal-proceedings.risk.confirm_dialog',
  },
  close: {
    id: 'legal-proceedings.risk.close_dialog',
  },
  victimInformationTitle: {
    id: 'legal-proceedings.risk.victim_information.title',
  },
  vehicleInformationTitle: {
    id: 'legal-proceedings.risk.vehicle_information.title',
  },
  additionalGarentiesTitle: {
    id: 'legal-proceedings.risk.additional_garenties_information.title',
  },
  judgementAmount: {
    id: 'legal-proceedings.risk.risk_information.compensation_amount',
  },
  appealCompensationAmount: {
    id: 'legal-proceedings.risk.risk_information.appeal_compensation_amount',
  },
  deceasedMedicalFees: {
    id: 'legal-proceedings.risk.risk_information.deceased_medical_fees',
  },
  deceasedFuneralFees: {
    id: 'legal-proceedings.risk.risk_information.deceased_funeral_fees',
  },
  beneficiaryAppealCompensationAmount: {
    id:
      'legal-proceedings.risk.risk_information.appeal_beneficiary_compensation_amount',
  },
  judgementCompensationAmount: {
    id: 'legal-proceedings.risk.risk_information.judgement_compensation_amount',
  },
  beneficiaryCompensationAmount: {
    id:
      'legal-proceedings.risk.risk_information.beneficiary_compensation_amount',
  },
  beneficiaryCalculatedCompensationAmount: {
    id: 'legal-proceedings.risk.risk_information.beneficiary_calculated_amount',
  },
  judgementCalculatedAmount: {
    id: 'legal-proceedings.risk.risk_information.judgement_calculated_amount',
  },
  appealCalculatedAmount: {
    id: 'legal-proceedings.risk.risk_information.appeal_calculated_amount',
  },
  judgementCompanyAmount: {
    id: 'legal-proceedings.risk.risk_information.judgement_company_amount',
  },
  principalAmount: {
    id: 'legal-proceedings.risk.risk_information.principal_amount',
  },
  damageAmount: {
    id: 'legal-proceedings.risk.risk_information.damage_amount',
  },
  appealDamageAmount: {
    id: 'legal-proceedings.risk.risk_information.appeal_damage_amount',
  },
  judgementDamageAmount: {
    id: 'legal-proceedings.risk.risk_information.judgement_damage_amount',
  },
  rate: {
    id: 'legal-proceedings.risk.risk_information.rate',
  },
  judgementIndemnityAmount: {
    id:
      'legal_proceeding_page.judgement_on_merits.calculated_compensation_field',
  },
  ratePercentage: {
    id: 'legal-proceedings.risk.risk_information.rate_percentage',
  },
  judgementInformation: {
    id: 'legal-proceedings.risk.risk_information',
  },
  victimRiskInformation: {
    id: 'legal-proceedings.risk.risk_victim_type',
  },
  minorVictims: {
    id: 'legal-proceedings.risk.minor_victims',
  },
  adultVictims: {
    id: 'legal-proceedings.risk.adult_victims',
  },
  tpi: {
    id: 'legal-proceedings.risk.judgement_court_number',
  },
  appealCourt: {
    id: 'legal-proceedings.risk.judgement_court_number',
  },
  status: { id: 'legal-proceedings.risk.status' },
  levelRequirement: { id: 'legal-proceedings.risk.level_requirement' },
  paymentChannel: { id: 'legal-proceedings.risk.payment_channel' },
  paymentMethod: { id: 'legal-proceedings.risk.payment_method' },
  totalAmount: { id: 'legal-proceedings.risk.total_amount' },
  validationButton: { id: 'legal-proceedings.risk.create_regulation' },
  updateButton: { id: 'legal-proceedings.risk.update_document_regulation' },
  successCorpoToastTitle: {
    id: 'legal-proceedings.risk_corporeal.creation.toast_success',
  },
  successMaterialToastTitle: {
    id: 'legal-proceedings.risk_material.creation.toast_success',
  },
  successAdditionalWarrentiesToastTitle: {
    id: 'legal-proceedings.risk_additional_warrenties.creation.toast_success',
  },
  city: {
    id: 'legal-proceedings.risk.risk_information.city',
  },
  bnejCity: {
    id: 'legal-proceedings.risk.risk_information.bnej_city',
  },
  claimNumber: { id: 'legal-proceedings.risk.history.claim_number' },
  riskName: { id: 'legal-proceedings.risk.history.risk_name' },
  paymentRegulation: {
    id: 'legal-proceedings.risk.history.payment_regulation',
  },
  statusRegulation: { id: 'legal-proceedings.risk.history.status_regulation' },
  validator: { id: 'legal-proceedings.risk.history.validator' },
  summarySheet: { id: 'legal-proceedings.risk.history.summary_sheet' },
  cdraOrCnraSheet: { id: 'legal-proceedings.risk.history.cdra_or_cnra_sheet' },
  beneficiary: { id: 'legal-proceedings.risk.history.beneficiary' },
  documentType: { id: 'legal-proceedings.risk.history.document_type' },
  linkToBeneficiary: {
    id: 'legal-proceedings.risk.information.linkToBeneficiary',
  },
  minor: { id: 'legal-proceedings.risk.minor' },
  provisionalExecutionAmount: {
    id: 'legal-proceedings.risk.risk_information.provisional_execution_amount',
  },
  beneficiaryJudgementAmount: {
    id:
      'legal_proceeding_page.judgement_on_merits.beneficiary.judgement_amount',
  },
  beneficiaryAppealAmount: {
    id: 'legal_proceeding_page.judgement_on_merits.beneficiary.appeal_amount',
  },
  jomValidation: { id: 'legal-proceedings.risk.jom_validation' },
  jomPartialValidation: { id: 'legal-proceedings.risk.jom_partial_validation' },
  alertCity: { id: 'legal-proceedings.risk.alert.city_cdra' },
  deceasedVictims: { id: 'legal-proceedings.risk.side_recap.deceased_victim' },
  injuredVictims: { id: 'legal-proceedings.risk.side_recap.injured_victim' },
  summaryJudicialRuling: { id: 'summary_sheet.judicial_ruling' },
  provisionalExecution: { id: 'summary_sheet.provisional_execution' },
  lawyerPc: { id: 'summary_sheet.pc_lawyer' },
  lawyerCie: { id: 'summary_sheet.cie_lawyer' },
  summaryClaimNumber: { id: 'summary_sheet.claim_number' },
  summaryConnexe: { id: 'summary_sheet.connexe' },
  driver: { id: 'summary_sheet.driver' },
  beneficiaries: { id: 'summary_sheet.beneficiary_name' },
  judgement: { id: 'summary_sheet.judgement' },
  appeal: { id: 'summary_sheet.appeal' },
  amountReason: { id: 'summary_sheet.amount_reason' },
  date: { id: 'summary_sheet.date' },
  summaryRecipient: { id: 'summary_sheet.recipient' },
  court: { id: 'summary_sheet.court' },
  bnejNumber: { id: 'summary_sheet.bnej_number' },
  judgementOf: { id: 'summary_sheet.judgement_of' },
  appealOf: { id: 'summary_sheet.appeal_of' },
  insuredVehicle: { id: 'summary_sheet.insured_vehicle' },
  totalJudgement: { id: 'summary_sheet.total_judgement' },
  totalAppeal: { id: 'summary_sheet.total_appeal' },
  exeProv: { id: 'summary_sheet.exe_prov' },
  interests: { id: 'summary_sheet.interests' },
  cnra: { id: 'summary_sheet.CNRA' },
  bnej: { id: 'summary_sheet.BNEJ' },
  regulationDetails: { id: 'summary_sheet.regulation_details' },
  mainCompensation: { id: 'summary_sheet.main_compensation' },
  withIDD: { id: 'summary_sheet.is_idd' },
  abandon: { id: 'summary_sheet.abandon' },
  abandonRefused: { id: 'summary_sheet.abandon_refused' },
  abandonTotal: { id: 'summary_sheet.abandon_total' },
  abandonPartial: { id: 'summary_sheet.abandon_partial' },
  part: { id: 'summary_sheet.part' },
  executionAmount: { id: 'summary_sheet.execution_amount' },
  legalInterests: { id: 'summary_sheet.legal_interests' },
  from: { id: 'summary_sheet.from' },
  to: { id: 'summary_sheet.to' },
  tax: { id: 'summary_sheet.tax' },
  validatorManager: { id: 'summary_sheet.manager_validator' },
  transportation: { id: 'summary_sheet.transportation' },
  treasure: { id: 'summary_sheet.treasure' },
  compensation: { id: 'summary_sheet.compensation' },
  summaryCosts: { id: 'summary_sheet.costs' },
  fee: { id: 'summary_sheet.fee' },
  oldProvision: { id: 'summary_sheet.old_provision' },
  liabilityAssured: { id: 'summary_sheet.liability_assured' },
  newProvision: { id: 'summary_sheet.new_provision' },
  currentRegulation: { id: 'summary_sheet.current_regulation' },
  withAppeal: { id: 'summary_sheet.is_appeal' },
  yes: { id: 'summary_sheet.yes' },
  no: { id: 'summary_sheet.no' },
  CDRA: { id: 'summary_sheet.cdra' },
  visa: { id: 'summary_sheet.visa' },
  executionRate: { id: 'summary_sheet.execution_rate' },
  oldRegulation: { id: 'summary_sheet.old_regulation' },
  stopEntry: { id: 'summary_sheet.stop_entry' },
  feeNotes: { id: 'summary_sheet.fee_notes' },
  headOfDepartmentVisa: { id: 'summary_sheet.head_of_department_visa' },
  headOfServiceVisa: { id: 'summary_sheet.head_of_service_visa' },
  modificationReasons: { id: 'summary_sheet.reasons_of_modification' },
  total: { id: 'summary_sheet.total' },
  check_payed_by: { id: 'summary_sheet.check_payed_by' },
  remainder: { id: 'summary_sheet.remainder' },
  judgementReason: { id: 'summary_sheet.judgement.update_reason' },
  appealReason: { id: 'summary_sheet.appeal.update_reason' },
  funeralFees: { id: 'summary_sheet.funeral_fees' },
  medicalFees: { id: 'summary_sheet.medical_fees' },
  remainderAmount: { id: 'legal-proceedings.risk.remainder' },
  updateVictimDialogTitle: {
    id: 'legal-proceedings.risk.confirmation_dialog_victim_title',
  },
  updateDialogFeesTitle: {
    id: 'legal-proceedings.risk.dialog.update_fees_title',
  },
  updateBeneficiaryDialogTitle: {
    id: 'legal-proceedings.risk.confirmation_dialog_beneficiary_title',
  },
  regulationVictimFraud: { id: 'legal-proceedings.risk.fraud_victim' },
  regulationVehicleFraud: { id: 'legal-proceedings.risk.fraud_vehicle' },
  cancelButton: { id: 'provision_regulation.dialog.cancel' },
  confirmationButton: { id: 'provision_regulation.dialog.confirm' },
  updateProvisionSuccessToast: {
    id: 'edit_provision_intervenant_success_message',
  },
  updateProvisionTitle: { id: 'provision_regulation.update_title' },
  updateProvisionContent: { id: 'provision_regulation.update_content' },
  provisionAmount: {
    id: 'provision_amount',
  },
  provisionComment: {
    id: 'provision_regulation.dialog.comment',
  },
  summarySheetGenerationToaster: {
    id: 'legal-proceedings.risk.summary_sheet_success_toast',
  },
  cnraSheetGenerationToast: {
    id: 'legal-proceedings.risk.cnra_sheet_success_toast',
  },
  cdraSheetGenerationToast: {
    id: 'legal-proceedings.risk.cdra_sheet_success_toast',
  },
  provisionReason: {
    id: 'legal-proceedings.risk.summary_sheet.provision_reason',
  },
  medicalFeesReason: {
    id: 'legal-proceedings.risk.summary_sheet.medical_fees',
  },
  funeralFeesReason: {
    id: 'legal-proceedings.risk.summary_sheet.funeral_fees',
  },
  regulationRecap: {
    id: 'legal-proceedings.risk.history.regulation_recap',
  },
  validationRegulationButton: {
    id: 'legal-proceedings.risk.history.validation_button',
  },
  validationRegulationDrawerTitle: {
    id: 'legal-proceedings.risk.history.validation_drawer_title',
  },
  validationRegulationDrawerButtonTitle: {
    id: 'drawer.court_manager.validateWarrantyReason_title',
  },
  rejectionRegulationDrawerButtonTitle: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.reject',
  },
  RegulationValidation: {
    id: 'regulation_validation_dialog.validate_title',
  },
  RegulationRejection: {
    id: 'regulation_validation_dialog.reject_title',
  },
  RegulationValidationComment: {
    id: 'regulation_validation_dialog.comment_title',
  },
  RegulationValidationReason: {
    id: 'regulation_validation_dialog.input_label',
  },
  RegulationVaidationDialogCancel: {
    id: 'saham_dialog.cancel',
  },
  RegulationVaidationDialogSuccess: {
    id: 'regulation_validation_dialog.validation_success',
  },
  RegulationRejectionDialogSuccess: {
    id: 'regulation_validation_dialog.rejection_success',
  },
  cnraProvisionalExecution: { id: 'summary_sheet.CNRA.prov' },
  cnraRemainder: { id: 'summary_sheet.CNRA.remainder' },
  failedSummarySheetToast: {
    id: 'legal-proceedings.risk.summary_sheet_failed_toast',
  },
  back: {
    id: 'back_move_buttons.back',
  },
  rejectReason: {
    id: 'court_manager_legal_proceedings_page.regulation.refusal_popin.title',
  },
  processType: {
    id: 'search_bar.search_form_label_procedure_type',
  },
  responsabilityShare: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_responsability_share',
  },
  historyEmpty: {
    id: 'timeline_history.drawer.history_empty',
  },
  consultationMode: {
    id: 'timeline_history.drawer.consultation_mode',
  },
  regulationNotPending: {
    id: 'timeline_history.drawer.regulation_not_pending',
  },
  rejectedStatusInHistory: {
    id: 'timeline_history.drawer.rejected_status_in_history',
  },
  allStatusesValidated: {
    id: 'timeline_history.drawer.all_statuses_validated',
  },
  currentUserIsCreator: {
    id: 'timeline_history.drawer.current_user_is_creator',
  },
  noAccessToManagerInbox: {
    id: 'timeline_history.drawer.no_access_to_manager_inbox',
  },
  assignedLawyerTitle: {
    id: 'legal-proceedings.assigned_lawyers',
  },
  bnejNumberTitle: {
    id: 'legal-proceedings.risk.information.bnej_number',
  },
  warningVictim: {
    id: 'legal-proceedings.risk.recap-victims.warning',
  },
});
